<div id="container">
    <header id="header" class="header">

        <img class="logo" src="../../../assets/images/logo_2x.png" alt="Vcircle Logo">

        <nav class="nav">
            <ul class="row_ul">
                <li *ngFor="let link of links" class="nav__item">
                    <a [href]="link.href" class="none">
                        {{link.text}}
                    </a>
                </li>
            </ul>
        </nav>

        <ul class="row_ul buttons">
            <!-- <li><a href="https://vcircle.ng/login" target="_blank" class="buttons__item none">Login</a></li>
            <li><a href="/register" class="buttons__item button--dark none header_register_btn">Get Started</a></li> -->
        </ul>


        <div class="sidemenu-controllers">
            <img src="../../../assets/icons/x-icon.svg" *ngIf="util.isSideMenuOpen()" (click)="util.closeSidemenu()"
                alt="Cancel icon" class="x-icon">
            <img src="../../../assets/icons/menu-icon.svg" *ngIf="!util.isSideMenuOpen()" (click)="util.openSideMenu()"
                alt="Menu icon" class="menu-icon">
        </div>
    </header>
    <section id="hero" class="hero">
        <div class="hero__text my-5">
            <h4 class="hero__subtitle my-5">Stay Connected with Clarity</h4>
            <h1 class="hero__title my-5">Seamless Video Calls, Anytime, Anywhere</h1>
            <p class="hero__description my-5">V Circle is a cutting-edge video call platform designed to bring people
                closer—whether for business meetings, virtual events, or catching up with loved ones. With crystal-clear
                audio, high-definition video, and seamless connectivity, V Circle ensures that every conversation feels
                natural and effortless.</p>
            <!-- <a href="/register" class="hero__cta button--dark">Get Started</a> -->
        </div>
        <img class="hero__img" id="hero__img" src="../../../assets/images/hero_img_full.png" alt="Woman in meeting" />

        <img src="../../../assets/images/hero_showcase_2x.png" alt="Meeting background edit" class="hero__phone"
            id="hero__phone">
    </section>
    <!-- <section id="partners" class="partners">
        <h2 class="title--primary">Trusted by Leading Businesses Worldwide</h2>
        <div class="scroll">
            <ul class="partners__list m-scroll">
                <li class="partners__item m-scroll__item" *ngFor="let partner of partners; trackBy: identify">
                    <img [src]="partner.src" [alt]="partner.alt">
                </li>
                <li class="partners__item m-scroll__item" *ngFor="let partner of partners; trackBy: identify">
                    <img [src]="partner.src" [alt]="partner.alt">
                </li>
            </ul>
        </div>
    </section> -->
    <section id="about" class="about">
        <img src="../../../assets/images/about_img_2x.png"
            alt="Business student having online video call meeting conference" class="about__img" id="about__img">

        <div class="about__text" id="about__text">
            <h4 class="text-subtitle">Stay Connected with Clarity</h4>
            <h2 class="text-title">Seamless Video Calls, Anytime, Anywhere</h2>
            <p class="text-description">Vcircle is a cutting-edge video call platform designed to bring people
                closer—whether for business meetings, virtual events, or catching up with loved ones. With crystal-clear
                audio, high-definition video, and seamless connectivity, V Circle ensures that every conversation feels
                natural and effortless.</p>
            <!-- <a href="/register" class="button--dark">Get Started</a> -->
        </div>
    </section>
    <section id="communication" class="communication">
        <h2 class="text-title">Get Optimal Communication In 4 Steps</h2>
        <p class="text-description communication__desc my-5">
            Our streamlined process ensures a seamless, secure, and stable connection for users. With our platform, you
            can connect with anyone, anywhere in just five simple steps. Our mission is to break communication barriers,
            offering a user-friendly, accessible, and reliable way to connect with anyone, anywhere.
        </p>
        <!-- <a href="/register" class="button--dark mb-5">Get Started</a> -->
        <br>
        <br>
        <p class="text-description communication_how">How we deliver</p>

        <ol class="communication__steps" id="communication__steps">
            <ng-container *ngFor="let step of deliverySteps; index as i">
                <li class="communication__steps_item">
                    <img [src]="step.iconSrc" [alt]="step.iconAlt">
                    <span class="text-description communication__steps_item_text">{{step.text}}</span>
                </li>
                <img src="assets/icons/next_step.svg" class="communication__steps_item_next" alt="Next step"
                    *ngIf="i < deliverySteps.length - 1" />
            </ng-container>
        </ol>

        <ul class="communication__chips">
            <li class="communication__chips_item text-description">HD Video Calls</li>
            <li class="communication__chips_item text-description">Instant meeting links</li>
            <li class="communication__chips_item text-description">Secure and private</li>
        </ul>

        <img src="../../../assets/images/device_vcircle.png" alt="Mobile device on vcircle platform"
            class="communication__main_img">

    </section>

    <section id="services" class="services">
        <h4 class="text-subtitle">Our Services</h4>
        <h2 class="text-title">Why Choose Our Platform</h2>

        <ul class="services__list" id="services__list">
            <li class="services__list_item" *ngFor="let service of services">
                <img [src]="service.iconSrc" [alt]="service.iconAlt">
                <h5 class="text-title">{{service.text}}</h5>
                <p class="text-description">{{service.description}}</p>
            </li>
        </ul>
        <!-- <a href="/register" class="button--dark">Get Started</a> -->
    </section>

    <section id="industries" class="industries">
        <div class="industries__card">
            <h4 class="text-title">Industries</h4>
            <small class="industries__card_desc">Our platform can be used by various people in various
                industries</small>
            <ul class="industries__list" id="industries__list">
                <li *ngFor="let industry of industries" class="industries__list_item text-description">
                    <small>{{industry}}</small>
                </li>
            </ul>
        </div>
    </section>

    <!-- <section id="reviews" class="reviews">
        <h2 class="text-title reviews__title">What Our Customers Are Saying</h2>
        <ul class="reviews__list">
            <li *ngFor="let review of reviews" class="reviews__list_item">
                <div class="top">
                    <img [src]="review.profileSrc" height="48px" width="48px" alt="Profile picture top_img">
                    <h6 class="text_weak top_name">{{review.name}}</h6>
                    <small class="text_weak top_bio">{{review.bio}}</small>
                </div>
                <p class="text_weak reviews__list_item_text">{{review.review}}</p>
            </li>
        </ul>
    </section> -->

    <!-- <section id="contact" class="contact">
        <div class="contact__left">
            <p class="contact__left_subtitle">
                Contact Us?
            </p>
            <h3 class="contact__left_title">
                Let's Connect — We're Here to Support Your Practice
            </h3>
            <p class="contact__left_desc">
                Whether you have questions about our services, need assistance with your practice's digital
                transformation, or are ready to take your operations to the next level, the Frontage MD team is here for
                you.
            </p>
        </div>
        <form class="contact__right" [formGroup]="contactForm">
            <h3 class="contact__right_subtitle">Say Hello</h3>

            <div class="contact__right_grid">
                <label for="form_name" class="contact__right_label label_name">
                    Name (required)
                    <input type="text" id="form_name" class="contact__right_input" name="form_name"
                        formControlName="form_name" placeholder="Your name"
                        [ngClass]="{'invalid_input': contactForm.controls.form_name.invalid && contactForm.controls.form_name.touched}">
                </label>
                <label for="form_contact" class="contact__right_label">
                    Practice (optional)
                    <input type="text" id="form_contact" class="contact__right_input" name="form_practice"
                        formControlName="form_practice" placeholder="Your practise name"
                        [ngClass]="{'invalid_input': contactForm.controls.form_practice.invalid && contactForm.controls.form_practice.touched}">
                </label>
                <label for="form_email" class="contact__right_label--full">
                    Email (required)
                    <input type="text" id="form_email" class="contact__right_input" name="form_email"
                        formControlName="form_email" placeholder="Email (required)"
                        [ngClass]="{'invalid_input': contactForm.controls.form_email.invalid && contactForm.controls.form_email.touched}">
                </label>
                <label for="form_message" class="contact__right_label--full">
                    Message (required)
                    <textarea type="text" id="form_message" class="contact__right_input--textarea" name="form_message"
                        formControlName="form_message" placeholder="Brief project details"
                        [ngClass]="{'invalid_input': contactForm.controls.form_message.invalid && contactForm.controls.form_message.touched}"></textarea>
                </label>
                <label for="form_subscribe" class="contact__right_label--checkbox">
                    I'm okay with getting emails and having that activity tracked to improve my experience.
                    <input type="checkbox" id="form_subscribe" class="contact__right_input--checkbox"
                        name="form_subscribe" formControlName="form_subscribe" placeholder="Your name"
                        [ngClass]="{'invalid_input': contactForm.controls.form_subscribe.invalid && contactForm.controls.form_subscribe.touched}">
                </label>

                <a (click)="submitForm()" class="submit button--dark">
                    Submit
                </a>


            </div>
        </form>
    </section> -->

    <section id="join" class="join">
        <h3 class="join__title text-title">
            Join the Circle
        </h3>
        <p class="join__description">
            Whether you're hosting a virtual conference, remote work meeting, or casual video hangout, V Circle adapts
            to your needs. Start your video call journey today! Sign up now and experience seamless communication with V
            Circle.
        </p>
        <!-- <a href="" class="join__cta button--dark">
            Get Started
        </a> -->
    </section>



    <section id="footer" class="footer">
        <!-- <div class="footer__left">
            <img src="../../../assets/images/logo_2x.png" alt="V-Circle Logo" class="footer__left_top">
            <ul class="footer__left_icons">
                <li class="footer__left_icons_item" *ngFor="let icon of footerIcons">
                    <img [src]="icon.src" [alt]="icon.alt">
                </li>
            </ul>
        </div> -->

        <div class="footer__mid">
            <h5 class="footer__mid_title">Get in touch</h5>
            <p class="footer__mid_desc">
                <!-- <span>Contact and general info</span>
                <br> -->
                <br>
                <span>Email: info@todayssolutions.com.ng </span>
                <br>
                <!-- <span>Website: www.v-circle.ng</span>
                <br>
                <span>Address: 79,siisowbo, lagos</span>
                <br> -->
                <span>Phone: +234 809 123 4679</span>
            </p>

        </div>

        <!-- <div class="footer__right">
            <h5 class="footer__right_title">Sign up for the newsletter</h5>
            <form action="" class="footer__right_form">
                <div class="footer__right_form_top">
                    <input type="text" class="footer__right_input" placeholder="you@domain.com">
                    <button class="footer__right_input_button">Sign Up</button>
                </div>

                <label for="form_newsletter" class="footer__right_label--checkbox">
                    I'm okay with getting emails and having that activity tracked to improve my experience.
                    <input type="checkbox" id="form_newsletter" class="footer__right_input--checkbox"
                        name="form_newsletter">
                </label>
            </form>
        </div> -->
    </section>

    <footer id="end" class="end">
        <ul class="end__list">
            <li class="">© 2023 VCircle. All rights reserved.</li>
            <!-- <li class="end__list_item">Privacy policy</li>
            <li class="end__list_item">Terms of Service</li> -->
        </ul>
    </footer>


    <nav class="sidemenu" id="sidemenu"
        [ngClass]="{'sidemenu--open': util.isSideMenuOpen(), 'sidemenu--close': !util.isSideMenuOpen()}">
        <ul class="sidemenu__links">
            <li *ngFor="let link of links" class="sidemenu__links__item">
                <a [href]="link.href" class="none">{{link.text}}</a>
            </li>
            <li class="sidemenu__links__item nav_register_btn">
                <!-- <a href="/register"
                    class="buttons__item button--dark none">
                    Get Started
                </a> -->
            </li>
        </ul>
    </nav>
</div>